
import Vue from "vue";

export default Vue.extend({
  name: "BtnIcon",
  props: {
    rounded: Boolean,
    show_text: {
      type: Boolean,
      default: false,
    },
    show_icon: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: "Botón",
    },
    icono: {
      type: String,
      default: "mdi-bash",
    },
    color: {
      type: String,
      default: "info",
    },
    tooltip: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    confirmacion: {
      type: Boolean,
      default: false,
    },
    titulo_confirmacion: {
      type: String,
      default: "Confirmación",
    },
    texto_confirmacion: {
      type: String,
      default: "¿Desea realmente ejecutar la acción?",
    },

    texto_boton_si: {
      type: String,
      default: "Sí",
    },
    texto_boton_no: {
      type: String,
      default: "No",
    },
    traduccir: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false as boolean,
    };
  },
  components: {},
  methods: {
    accion() {
      this.$emit("accion");
    },
  },
});
